// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"228":"252f366e","445":"1bfc9850","678":"component---src-pages-index-js","883":"component---src-pages-404-js","994":"b98bc7c3"}[chunkId] + "-" + {"228":"27902bf2a16b7e2f2dd5","445":"8d2f13132d678878b161","678":"924f772ee6c5ec21ac08","883":"67277575a28ae1228688","994":"d7d38717376fe32f0caf"}[chunkId] + ".js";
};